export const getResponseProblem = (statusCode) => {
  let problem = null
  if (statusCode >= 200 && statusCode <= 299) {
    problem = null
  } else if (statusCode === 403 || statusCode === 401) {
    problem = 'UNAUTHORIZED'
  } else if (statusCode >= 400 && statusCode <= 499 && statusCode !== 403 && statusCode !== 408) {
    problem = 'CLIENT_ERROR'
  } else if (statusCode >= 500 && statusCode <= 599) {
    problem = 'SERVER_ERROR'
  } else if (statusCode === 408) {
    problem = 'TIMEOUT_ERROR'
  } else if (statusCode === null) {
    problem = 'OFFLINE'
  } else {
    problem = 'NETWORK_ERROR'
  }
  return problem
}

export const isResponseOK = (statusCode) => {
  return (statusCode >= 200 && statusCode <= 299) ? true : false
}

export const responseProcessor = (response) => {
  if (response) {
    response.ok = isResponseOK(response.status)
    response.problem = getResponseProblem(response.status)
  } else {
    response = {}
    response.ok = isResponseOK(null)
    response.problem = getResponseProblem(null)
  }
  return response
}

export default {
  getResponseProblem,
  isResponseOK,
  responseProcessor,
}
